interface Array<T> {
    /** Returns a copy of the array, sorted according to the value selector function */
    sortBy(valueSelectorFunc: (item: T) => any): Array<T>,

    /** Returns a lookup map, grouping items according to the value selection function */
    toLookup(keySelectorFunc: (item: T) => string): Map<string, T[]>,

    /** Returns a map, indexing items according to the value selection function
     *  @throws: An exception in case of duplicate items
     * */
    toMap(keySelectorFunc: (item: T) => string): Map<string, T>,

    distinct(): Array<T>
}

if (!Array.prototype.sortBy) {
    Array.prototype.sortBy = function <T>(valueSelectorFunc: (item: T) => any): Array<T> {
        const sortAscFunc = (itemA: T, itemB: T) => {
            const valueA = valueSelectorFunc(itemA)
            const valueB = valueSelectorFunc(itemB)

            if (valueA === valueB) return 0
            return valueA > valueB ? 1 : -1
        }

        return [...this].sort(sortAscFunc)
    }
}

if (!Array.prototype.toLookup) {
    Array.prototype.toLookup = function <T>(keySelectorFunc: (item: T) => string): Map<string, T[]> {
        const lookup: { [key: string]: T[] } = {}

        for (const item of this) {
            const key: string = keySelectorFunc(item);
            (lookup[key] = (lookup[key] || [])).push(item)
        }

        return new Map<string, T[]>(Object.entries(lookup))
    }
}

if (!Array.prototype.toMap) {
    Array.prototype.toMap = function <T>(keySelectorFunc: (item: T) => string): Map<string, T> {
        const map: { [key: string]: T } = {}

        for (const item of this) {
            const key: string = keySelectorFunc(item)
            if (map[key]) {
                throw `ERROR in toMap: Duplicate item ${key}!`
            }
            map[key] = item
        }

        return new Map<string, T>(Object.entries(map))
    }
}

if (!Array.prototype.distinct) {
    Array.prototype.distinct = function<T> (): Array<T> {
        return this.filter((item, index) => this.indexOf(item) === index)
    }
}

